export default __webpack_public_path__ + "static/media/lyve-logo.185e37b6.webp";